import React from 'react';

/* External */
import PropTypes from 'prop-types';

/* Styles */
import './TracksMenu.scss';

/**
 * Component TracksMenu
 * @description Method that shows a list of selectable tracks
 */
function TracksMenu({
  title,
  tracks = [],
  onSelectTrack = () => {},
  getLanguageLabel = () => {},
}) {
  return (
    <ul className="dtv-common-c-tracks-menu-v2" role="menu">
      {title && (
        <li className="dtv-common-c-tracks-menu-v2__title" tabIndex="-1">
          {title}
        </li>
      )}
      {tracks.map((track) => {
        const {
          id,
          isSelected,
        } = track;
        const elementItemClassName = 'dtv-common-c-tracks-menu-v2__item';
        return (
          <li
            key={id || '0'}
            className={`${elementItemClassName} ${
              isSelected ? `${elementItemClassName}--selected` : ''
            }`}
          >
            <div
              className="dtv-common-c-tracks-menu-v2__interactive-item"
              tabIndex="-1"
              role="menuitemradio"
              aria-checked={isSelected}
              onClick={(event) => {
                event.stopPropagation();
                onSelectTrack(track);
              }}
              onKeyDown={() => {}}
            >
              {getLanguageLabel(track)}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

TracksMenu.propTypes = {
  title: PropTypes.string,
  tracks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    isSelected: PropTypes.bool,
    name: PropTypes.string,
  })),
  onSelectTrack: PropTypes.func,
  getLanguageLabel: PropTypes.func,
};

TracksMenu.defaultProps = {
  title: '',
  tracks: [],
  onSelectTrack: () => {},
  getLanguageLabel: () => {},
};

export default TracksMenu;
